import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';

const cardEase = `cubic-bezier(0, 0.3, 0.3, 1)`;
const cardTransition = `.16s ${cardEase}`;

export const StyledThumbnail = styled.div`
  z-index: 0;
  display: block;
  width: 100%;
  overflow: hidden;
  background-color: var(--color-level-0);
  transition: all ${cardTransition};
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  .thumbnail {
    display: block;
    width: 100%;
    height: auto; /* OR: auto */
    transition: all ${cardTransition};
    opacity: 1;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: auto;

    h6 {
      position: absolute;
      top: -900vh;
      left: -900vh;
      opacity: 0;
      pointer-events: none;
    }
  }
  .screen {
    position: absolute;
    z-index: 51;
    &.screenTopRight {
      top: var(--size-space-tiny);
      right: var(--size-space-tiny);
    }
    &.screenTopLeft {
      top: var(--size-space-tiny);
      left: var(--size-space-tiny);
    }
    &.screenBottomRight {
      bottom: var(--size-space-tiny);
      right: var(--size-space-tiny);
    }
    &.screenBottomLeft {
      bottom: var(--size-space-tiny);
      left: var(--size-space-tiny);
    }
  }
`;

export const StyledDetails = styled.div`
  align-self: flex-start;
  justify-self: center;
  width: 100%;
  position: relative;
  z-index: 5;
  transition: all ${cardTransition};
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    transition: transform 0.48s cubic-bezier(0, 0.25, 0, 1), opacity 0.25s ease;
  }

  /* ONLY ON DYNAMIC ? */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    /* margin-left: 0;
    margin-right: 0;
    max-width: none; */
  }
  h5,
  h6 {
    /* color: white;
    line-height: 1.33em; */
  }
  img {
    transition: all 0.4s ease;
    float: left;
    margin-left: 2.4rem;
    margin-right: 2.4rem;
    border-radius: 100%;
  }
  .detailsMeta {
    line-height: 0;
    margin: 0 0 0.4rem 0;
    font-size: 0;
    padding: 0 0 0.4rem 0;
    border-bottom: 1px solid var(--color-level-2);
  }
`;

export const StyledContainer = styled(Link)`
  /* ${props => console.log(props.theme)} */
  --color-primary-light: ${props => props.theme.color_light};
  --color-primary-dark: ${props => props.theme.color_dark};

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 5;
  background-color: var(--color-container);
  border: var(--size-space-small) solid transparent;

  .cardButton {
    margin-top: 1.6rem;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 1.6rem 2.4rem;
    border-radius: 0.8rem;
    transition: all ${cardTransition};
    p {
      color: var(--color-primary-light);
    }
  }

  &:hover {
    border-color: var(--color-primary-light);
    background-color: var(--color-primary-light);
  }
  ${props => {
    switch (props.theme.type) {
      case 'flexible':
        return `
            ${StyledThumbnail}{
              height: 100%;
              position: absolute;
              padding: 0px;
              background-image: url(${props.theme.image});
              .thumbnail {
                display: none;
              }
            }
            ${StyledDetails}{
              padding: 8rem 4rem;
              height: 100%;

              .image{
                height: 100%;
              }

              h1,h2,h3,h4,h5,h6,p{
                &.title {
                  font-size: 6.4rem;
                  font-weight: 900;
                  text-transform: uppercase;
                }
                &.subtitle{
                  font-size: 2.4rem;
                  opacity: 0.8;
                }
                &.description{
                  font-size: 3.2rem;
                  color: var(--color-primary-light);
                  opacity: 1;
                }
              }
            }
            &:hover{
              ${StyledDetails} {
                background-color: rgba(12,16,20,0.4);
              }
            }
          `;
      case 'inline':
      default:
        return `
            ${StyledThumbnail}{
              height: auto;
              position: relative;
            }
            ${StyledDetails}{
              background-color: var(--color-container);
              padding: 1.6rem;

              .image{
                height: auto;
              }
            }
            &:hover{
              ${StyledDetails} {
                transform: translateY(-2.4rem);
              }
            }
          `;
    }
  }}
`;

StyledContainer.propTypes = {
  theme: PropTypes.shape({
    type: PropTypes.oneOf(['inline', 'flexible']),
    color_light: PropTypes.string,
    color_dark: PropTypes.string,
    image: PropTypes.string,
  }),
};
StyledContainer.defaultProps = {
  theme: {
    type: 'inline',
  },
};
